<template>
	<div id="tu-information-tagline">
		<el-dialog
	    v-model="dialogVisible"
	    title="Edit your tagline"
	    width="26%"
	  >
	  	<el-input v-model="content" placeholder="Please keep your tagline below 60 characters." maxlength="60" show-word-limit />
	  	<div class="description">A short, snappy summary to promote yourself e.g. "Highly experienced English tutor and Literacy specialist"</div>
	    <template #footer>
	      <span class="dialog-footer">
	        <el-button @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
	        <el-button type="primary" @click="handleSaveOperation">{{ $t('Save') }}</el-button>
	      </span>
	    </template>
	  </el-dialog>
	</div>
</template>
<script>
import TeacherApi from '@/api/teacher'

export default {
	name: "tu-information-tagline",
	props: {
		profile: {
			type: Object,
			default: function() {
				return {}
			}
		}
	},
	components: {
		
	},
	data() {
		return {
			dialogVisible: false,
			content: ''
		}
	},
	watch: {
		profile() {
			this.content = this.profile.tagline || ''
		}
	},
	created() {
		
	},
	methods: {
		open() {
			this.dialogVisible = true;
		},
		handleSaveOperation() {
			if(!!!this.content) {
				this.$message.error("Relevant information is required");
				return ;
			}
			let params = {
				tagline: this.content
			}
			TeacherApi.store(params).then(res => {
				this.$message.success(this.$t('Save Success'));
				this.dialogVisible = false;
			})
		}
	}
}
</script>
<style lang="less">
#tu-information-tagline {
	.el-dialog {
		.el-dialog__body {
			padding-top: 5px;
		}
	}

	.description {
		color: var(--el-color-info);
		padding: 5px;
		line-height: 1.7;
	}

	.el-dialog__footer {
		text-align: center;
	}
}
</style>